import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

import ArchiveDesktopSearchForm from "./ArchiveDesktopSearchForm";
import ArchiveTransactionList from "../common/ArchiveTransactionList"
import { ProgressBar } from "react-bootstrap";
import Api from "../../utils/Api";
import moment from "moment";

export default function ArchiveTransactionArchive() {
    const [searchInProgress, setSearchInProgress] = useState(false);
    const [result, setResult] = useState(null);
    const [lookups, setLookups] = useState(null);
    const searchRef = useRef(null);
    const transactionListRef = useRef(null);
    const location = useLocation();

    useEffect(async () => {
        await getData();

        if (location.search.split("=")[1]) {
            const searchData = {
                startTime: moment().subtract(6, "month").toDate(),
                endTime: moment().toDate(),
                text: location.search.split("=")[1]
            };

            await search(searchData);
        }
    }, []);

    const getData = async function () {
        const { response: lookups } = await Api.lookups();
        setLookups(lookups);
    };

    const orderByAmount = () => {
        if (transactionListRef.current) {
            transactionListRef.current.orderByAmount();
        }
    };

    const listWasChanged = () => {
        searchRef?.current?.refreshSearch();
    };

    const search = async (searchData) => {
        setSearchInProgress(true);

        const params = {
            startTime: searchData.startTime,
            endTime: searchData.endTime,
            includeCategoryIds: searchData.categories,
            tagIds: searchData.tags,
            expenseOnly: false,
            incomeOnly: false,
            searchText: searchData.text,
            approvedOnly: searchData.approvedOnly,
        };

        let queryString = new URLSearchParams();
        for (let key in params) {
            queryString.append(key, params[key]);
        }
        const { response } = await Api.transactionsByCategory(params);
        const { items, sumOfTransactions } = response;
        setResult({ items, sumOfTransactions });
        setSearchInProgress(false);
        if (searchRef) {
            searchRef.current?.setTotalSearchAmount(sumOfTransactions.toFixed(2));
            searchRef.current?.setTransactionCount(items.length);
        }
        if (transactionListRef) {
            transactionListRef.current?.setItems(items);
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "right" }}>
            {lookups ? (
                <div style={{ width: "auto", margin: "auto" }}>
                    <ArchiveDesktopSearchForm
                        orderByAmount={orderByAmount}
                        searchCallback={search}
                        lookups={lookups}
                        totalSearchAmount={result?.sumOfTransactions.toFixed(2)}
                        transactionCount={result?.items.length}
                        ref={searchRef}
                    />

                    {searchInProgress ? <ProgressBar active now={100} /> : ""}

                    <ArchiveTransactionList
                        approvalMode={true}
                        lookups={lookups}
                        ref={transactionListRef}
                        listWasChanged={listWasChanged}
                    />
                </div>
            ) : (
                <div />
            )}
        </div>
    );
}
